import { TabConfig } from '@/app/navigation/types'
import { ReportsTab } from '../tabs/reports'

export const banqueTabs: TabConfig[] = [
  {
    id: 'reports',
    label: 'Rapports',
    icon: 'DocumentIcon',
    component: ReportsTab,
    path: '/banque/reports',
    position: 1,
    permissions: ['view_reports']
  }
]